<template>
  <div class="echart-box" ref="chartRef" tabindex="0" style="outline:none;">
    <div :ref="elRef" class="echart" :style="styles"/>
    <div class="context-menu" v-if="showDragZoom">
      <el-tooltip content="添加标注" placement="top-start" v-if="toolButtons.includes('addMark')">
        <div class="menu-item" @click="handleMenu('addMark')">
          <i class="el-icon-edit"/>
        </div>
      </el-tooltip>
      <el-tooltip content="清除标注" placement="top-start" v-if="toolButtons.includes('addMark')">
        <div class="menu-item" @click="handleMenu('clearMark')">
          <svg-icon icon-class="clearMark" style="font-size: 16px"/>
        </div>
      </el-tooltip>
      <el-tooltip content="滤波" placement="top-start" v-if="toolButtons.includes('filtering')">
        <div class="menu-item" @click="handleMenu('filtering')">
          <svg-icon icon-class="filtering" style="font-size: 16px"/>
        </div>
      </el-tooltip>
      <el-tooltip content="双游标" placement="top-start" v-if="toolButtons.includes('doubleCursor')">
        <div :class="['menu-item',{'menu-item-active':doubleCursorEnabled}]" @click="handleMenu('doubleCursor')">
          <svg-icon icon-class="doubleCursor" style="font-size: 16px"/>
        </div>
      </el-tooltip>
      <el-tooltip content="频带数量" placement="top-start" v-if="toolButtons.includes('bandCount')">
        <div class="menu-item" @click="handleMenu('bandCount')">
          <i class="el-icon-setting"/>
        </div>
      </el-tooltip>
      <el-tooltip content="倍频" placement="top-start" v-if="toolButtons.includes('harmonics')">
        <div :class="['menu-item',{'menu-item-active':harmonicsEnabled}]" @click="handleMenu('harmonics')">
          <svg-icon icon-class="frequencyDoubling" style="font-size: 16px"/>
        </div>
      </el-tooltip>
      <el-tooltip content="边频" placement="top-start" v-if="toolButtons.includes('sideband')">
        <div :class="['menu-item',{'menu-item-active':sidebandEnabled}]" @click="handleMenu('sideband')">
          <svg-icon icon-class="edgeFrequency" style="font-size: 16px"/>
        </div>
      </el-tooltip>
      <el-tooltip content="指标" placement="top-start" v-if="toolButtons.includes('indicator')">
        <div class="menu-item" @click="handleMenu('indicator')">
          <svg-icon icon-class="indicator" style="font-size: 16px"/>
        </div>
      </el-tooltip>
      <el-tooltip content="峰值谱线图表" placement="top-start" v-if="toolButtons.includes('peakSpectrum')">
        <div class="menu-item" @click="handleMenu('peakSpectrum')">
          <i class="el-icon-data-line"/>
        </div>
      </el-tooltip>
      <el-tooltip content="加窗" placement="top-start" v-if="toolButtons.includes('windowing')">
        <div class="menu-item" @click="handleMenu('windowing')">
          <svg-icon icon-class="windowing" style="font-size: 16px"/>
        </div>
      </el-tooltip>
      <el-tooltip :content="isPlaying ? '暂停' : '播放'" placement="top-start" v-if="toolButtons.includes('audio')">
        <div class="menu-item" @click="togglePlay">
          <i :class="isPlaying ? 'el-icon-video-pause' : 'el-icon-video-play'"/>
        </div>
      </el-tooltip>
      <el-tooltip content="数据导出" placement="top-start">
        <div class="menu-item" @click="handleMenu('dataExport')">
          <i class="el-icon-document"/>
        </div>
      </el-tooltip>
      <el-tooltip content="导出图片" placement="top-start">
        <div class="menu-item" @click="handleMenu('export')">
          <i class="el-icon-download"/>
        </div>
      </el-tooltip>
      <el-tooltip :content="!isZoomActive?'开启缩放' : '关闭缩放'" placement="top-start">
        <div :class="['menu-item',{'menu-item-active':isZoomActive}]" @click="handleMenu('zoomIn')">
          <i :class="isZoomActive ? 'el-icon-close' : 'el-icon-zoom-in'"/>
        </div>
      </el-tooltip>
      <el-tooltip content="还原" placement="top-start">
        <div class="menu-item" @click="handleMenu('zoomOut')">
          <i class="el-icon-zoom-out"/>
        </div>
      </el-tooltip>
      <el-tooltip content="全屏" placement="top-start">
        <div class="menu-item" @click="handleMenu('fullscreen')">
          <i class="el-icon-full-screen"/>
        </div>
      </el-tooltip>
    </div>
    <MarkDialog ref="MarkDialogRef" @success="addMark"/>
    <Dialog title="游标数量设置" :show.sync="visible" width="400px">
      <template v-slot:body>
        <div class="dialog-body">
          <div>
            <el-form size="small" ref="form" :model="form" label-width="auto" label-position="top">
              <el-form-item
                  label="倍频游标个数"
                  prop="harmonicsNum">
                <el-input-number
                    style="width: 100%;"
                    :min="0"
                    :max="100"
                    step-strictly
                    :controls="false"
                    v-model="form.harmonicsNum"
                    :placeholder="$t('PleaseInput')"/>
              </el-form-item>
              <el-form-item
                  label="边频游标个数"
                  prop="sidebandNum">
                <el-input-number
                    style="width: 100%;"
                    :min="0"
                    :max="100"
                    step-strictly
                    :controls="false"
                    v-model="form.sidebandNum" :placeholder="$t('PleaseInput')"/>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">{{ $t('cancel_k') }}</el-button>
        <el-button size="small" type="primary" @click="save">{{ $t('confirm_k') }}</el-button>
      </div>
    </Dialog>
    <PeakValueDialog ref="PeakValueDialogRef"/>
    <BandwidthDialog ref="BandwidthDialogRef"/>
    <FilteringDialog ref="FilteringDialogRef" @success="setFilteringData"/>
    <TableIndicatorList ref="TableIndicatorListRef"/>
    <Windowing ref="WindowingRef"/>
  </div>
</template>

<script>
import {debounce} from 'lodash-es';
import dayjs from 'dayjs'
import BandwidthDialog from "@/views/dHistoryData/spectrum/components/BandwidthDialog.vue";
import PeakValueDialog from "@/views/dHistoryData/spectrum/components/PeakValueDialog.vue";
import MarkDialog from "@/views/dHistoryData/spectrum/MarkDialog.vue";
import FilteringDialog from "@/views/dHistoryData/spectrum/components/FilteringDialog.vue";
import {graphicTextStyle} from "@/common/js/dt/chart";
import * as XLSX from "xlsx";
import {getTopValuesBySecondItem} from "@/fetch/chartAlgorithm";
import TableIndicatorList from "@/views/dHistoryData/components/TableIndicatorList.vue";
import Windowing from "@/views/dHistoryData/components/Windowing.vue"

export default {
  name: 'EChart',
  components: {FilteringDialog, MarkDialog, PeakValueDialog, BandwidthDialog, TableIndicatorList, Windowing},
  props: {
    unit: {
      type: String,
      default: ''
    },
    selectGroup: {
      type: Object,
      default: () => {
      }
    },
    toolButtons: {
      type: Array,
      default: () => [] // 默认显示哪些按钮
    },
    options: {
      type: Object,
      required: true,
    },
    width: {
      type: [Number, String],
      default: '',
    },
    height: {
      type: [Number, String],
      default: '100%',
    },
    elRef: {
      type: String,
      default: 'elRef',
    },
    isClick: {
      type: Boolean,
      default: true,
    },
    xType: {
      type: String,
      default: 'time'
    },
    showDragZoom: {
      type: Boolean,
      default: true
    },
    chartName: {
      type: String,
      default: '图谱'
    },
    chartType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      echartRef: null,
      contentEl: null,
      resizeHandler: "",
      emitZoomDebounced: null,
      // 新增：标记是否是程序同步导致的缩放（非用户主动操作）
      isSyncZoom: false,
      isStartZoom: false,
      isZoomActive: false,
      isDragging: false,
      visible: false,
      markData: {},
      markText: '',
      markClosestIndex: 0,
      doubleCursorMark: {
        dataCoord: []
      },
      marks: [],
      markList: [],
      harmonicsEnabled: false,
      sidebandEnabled: false,
      form: {
        harmonicsNum: 20,
        sidebandNum: 20,
      },
      doubleCursorEnabled: false,
      doubleCursorCoordX: 0,
      isPlaying: false, // 默认未播放
      audio: null,        // 保存 audio 实例
      doubleCursorText: '',
      sidebandInterval: '',
      graphicElements: '',
      isActive: false
    };
  },
  computed: {
    styles() {
      const width = typeof this.width === 'string' ? this.width : `${this.width}px`;
      const height = typeof this.height === 'string' ? this.height : `${this.height}px`;
      return {width, height};
    },
    chart() {
      return this.$refs.chartRef
    },
    seriesData() {
      const series = Array.isArray(this.options.series) ? this.options.series[0] : this.options.series
      return Array.isArray(series?.data) ? series.data : []
    }
  },
  watch: {
    sidebandEnabled(nv) {
      if (!nv) this.sidebandInterval = ''
    },
    options: {
      handler(newOptions) {
        if (this.echartRef) {
          this.clearChart()
          this.echartRef.setOption(newOptions);
          this.enableZoom()
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.initChart();
    this.createDebouncedResizeHandler();
    window.addEventListener('chart-active-change', this.handleActiveChange);
    window.addEventListener('resize', this.resizeHandler);
    window.addEventListener('keydown', this.handleKeyDown);
    this.contentEl = document.getElementsByClassName('layout-content')[0];
    if (this.contentEl) {
      this.contentEl.addEventListener('transitionend', this.contentResizeHandler);
    }
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
  },
  beforeDestroy() {
    this.removeLegendSelectChangedListener();
    window.removeEventListener('chart-active-change', this.handleActiveChange);
    window.removeEventListener('resize', this.resizeHandler);
    window.removeEventListener('keydown', this.handleKeyDown);
    if (this.contentEl) {
      this.contentEl.removeEventListener('transitionend', this.contentResizeHandler);
    }
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    if (this.echartRef) {
      this.echartRef.dispose();
    }
  },
  methods: {
    handleActiveChange(e) {
      // 如果不是自己触发的，就取消激活
      if (e.detail !== this._uid) {
        this.isActive = false;
      }
    },
    getPeakValueList() {
      const data = this.seriesData || []
      if (data?.length) {
        return getTopValuesBySecondItem(data)
      }
      return []
    },
    togglePlay() {
      this.isPlaying = !this.isPlaying
      this.handleMenu(this.isPlaying ? 'play' : 'pause')
    },
    setFilteringData(filterData) {
      this.$emit('getFilterChartData', filterData)
    },
    // 添加倍频标记线
    addMarkLine(type) {
      // 检查是否有选中的点位
      if (!this.markData || !this.markData.dataCoord) {
        return;
      }
      // 创建新的图表选项，复制原有选项
      const newOptions = JSON.parse(JSON.stringify(this.options));
      let series = Array.isArray(newOptions.series) ? newOptions.series[0] : newOptions.series;
      // 确保有 markLine 配置
      if (!series) {
        series = {};
      }

      if (!series.markLine) {
        series.markLine = {
          symbol: ['none', 'none'],
          silent: true,
          data: []
        };
      }

      // 清除之前的倍频标记线
      series.markLine.data = series.markLine.data.filter(
          item => !item.harmonicLine
      );
      // 获取基础频率值
      const baseFreq = Number(this.markData.dataCoord[0]);
      // 生成7个倍频标记线
      let harmonicLines = [];
      if (type === 1) {
        for (let i = 2; i <= this.form.harmonicsNum; i++) {
          const harmonicFreq = baseFreq * i;
          const formaterValue = `${i}X`
          harmonicLines.push({
            name: `${i}X: ${harmonicFreq.toFixed(2)}`,
            xAxis: harmonicFreq,
            lineStyle: {
              color: '#FF9800',
              type: 'dashed',
              width: 1
            },
            label: {
              type: 'average',
              formatter: formaterValue,
              position: 'end', // 改为垂直显示在线的顶部
              rotate: -90,
              offset: [40, -5],
              fontSize: 12,
              color: '#FF9800',
            },
            harmonicLine: true // 标记为倍频线，方便后续识别
          });
        }
      } else if (type === 2) {
        const centerFreq = this.sidebandInterval// 间隔
        const num = this.form.sidebandNum // 边频数
        const markX = this.markClosestIndex
        const startNum = markX / centerFreq
        const frontNum = Math.floor(startNum)
// 往前绘制
        for (let i = 1; i <= frontNum && i <= num; i++) {
          const freq = this.seriesData[markX - centerFreq * i][0] - 0
          if (freq < 0) break // 小于 0 就不画
          harmonicLines.push({
            xAxis: freq,
            lineStyle: {
              color: '#FF9800',
              type: 'dashed',
              width: 1
            },
            label: {
              type: 'average',
              formatter: i === 1 ? `${this.seriesData[centerFreq][0]}` : '',
              position: 'end', // 改为垂直显示在线的顶部
              rotate: -90,
              offset: [20, -5],
              fontSize: 12,
              color: '#FF9800',
            },
            harmonicLine: true // 标记为倍频线，方便后续识别
          })
        }
// 往后绘制
        for (let i = 1; i <= num - frontNum; i++) {
          if (markX + centerFreq * i > this.seriesData.length) break;
          const freq = this.seriesData[markX + centerFreq * i][0] - 0
          if (freq < 0) break // 小于 0 就不画
          harmonicLines.push({
            xAxis: freq,
            lineStyle: {
              color: '#FF9800',
              type: 'dashed',
              width: 1
            },
            label: {
              type: 'average',
              formatter: i === 1 ? `${this.seriesData[centerFreq][0]}` : '',
              position: 'end', // 改为垂直显示在线的顶部
              rotate: -90,
              offset: [20, -5],
              fontSize: 12,
              color: '#FF9800',
            },
            harmonicLine: true // 标记为倍频线，方便后续识别
          })
        }

      }
      // 添加倍频标记线
      series.markLine.data = [
        ...series.markLine.data,
        ...harmonicLines
      ];
      this.updateChartOption({series})
      // 更新图表
    },
    // 添加清除倍频标记线的方法
    clearMarkLine(type) {
      if (type === 1) this.harmonicsEnabled = false
      if (type === 2) this.sidebandEnabled = false
      if (this.doubleCursorEnabled) {
        if (type === 3) this.doubleCursorEnabled = false
        const index = this.markList.findIndex(item => item.type === 'doubleCursor')
        if (index !== -1) this.markList.splice(index, 1)
        this.updateMarks()
      }
      // 创建新的图表选项，复制原有选项
      const newOptions = JSON.parse(JSON.stringify(this.options));
      newOptions.series.markLine = {
        data: []
      }
      // 更新图表
      this.updateChartOption({series: newOptions.series})
    },
    addMark({mark}) {
      this.markData.isNew = false
      this.markData.text = mark
      this.marks.push(this.markData)
      this.updateMarks()
    },
    handleMenu(action) {
      switch (action) {
        case 'zoomIn':
          this.isZoomActive = !this.isZoomActive;
          // 开启框选缩放
          this.echartRef.dispatchAction({
            type: 'takeGlobalCursor',
            key: 'dataZoomSelect',
            dataZoomSelectActive: this.isZoomActive
          });
          break;

        case 'zoomOut':
          // 关闭框选并重置缩放
          this.echartRef.dispatchAction({
            type: 'dataZoom',
            start: 0,
            end: 100
          });
          break;
        case 'addMark':
          // 添加标注逻辑
          if (this.markData.isNew) {
            this.$refs.MarkDialogRef.open(this.markData.text)
          }
          break;
        case 'clearMark':
          // 清除标注逻辑
          this.clearMarks()
          break;
        case 'bandCount':
          // 频带数量逻辑
          this.visible = true
          break;
        case 'harmonics':
          // 倍频逻辑
          if (this.harmonicsEnabled) {
            this.clearMarkLine(1)
          } else {
            this.harmonicsEnabled = true;
            this.sidebandEnabled = false;
            this.addMarkLine(1)
          }
          break;
        case 'sideband':
          if (this.sidebandEnabled) {
            this.clearMarkLine(2)
          } else {
            this.sidebandEnabled = true;
            this.harmonicsEnabled = false;
            this.sidebandInterval = this.sidebandInterval || this.markClosestIndex
            this.addMarkLine(2)
          }
          // 边频逻辑
          break;
        case 'featureFreq':
          // 特征频率逻辑
          break;
        case 'peakSpectrum':
          // 峰值谱线图表逻辑
          this.$refs.PeakValueDialogRef.open(this.getPeakValueList())
          break;
        case 'export':
          this.exportImg()
          // 导出逻辑
          break;
        case 'defaultBand':
          // 默认宽带逻辑
          this.$refs.BandwidthDialogRef.open()
          break;
        case 'doubleCursor':
          // 双游标逻辑
          if (this.doubleCursorEnabled) {
            this.doubleCursorText = ''
            this.markData.text = this.markText
            this.clearMarkLine(3)
          } else {
            this.doubleCursorEnabled = true;
            this.doubleCursorCoordX = 0;
            this.updateMarks()
          }
          break;
        case 'filtering':
          // 滤波逻辑
          this.$refs.FilteringDialogRef.open()
          break;
        case 'dataExport':
          this.exportToExcel(this.seriesData)
          // 数据导出逻辑
          break;
        case 'bearingFreq':
          // 轴承频率逻辑
          break;
        case 'pause':
          // 暂停逻辑
          if (this.audio) {
            this.audio.pause()
            this.isPlaying = false
          }
          break;
        case 'play':
          // 播放逻辑
          this.$emit('getAudioData')
          break;
        case 'indicator':
          this.$refs.TableIndicatorListRef.open(this.selectGroup, this.unit)
          break
        case 'windowing':
          // 清空逻辑
          this.$refs.WindowingRef.open()
          break;
        case 'fullscreen':
          this.toggleFullscreen()
          break;
      }
    },
    playAudio(res) {
      if (this.audio) {
        this.audio.pause()
        this.audio = null
      }
      const blob = new Blob([res], {type: 'audio/mpeg'})
      const audioUrl = URL.createObjectURL(blob)
      this.audio = new Audio(audioUrl)
      this.audio.play()
      this.isPlaying = true

      // 播放完毕后恢复状态
      this.audio.onended = () => {
        this.isPlaying = false
        this.audio = null
      }
    },
    pressDownLeft() {
      this.markClosestIndex--
      if (this.markClosestIndex < 0) return this.markClosestIndex = 0
      this.getClickData({closestIndex: this.markClosestIndex})
      this.$emit('getClickData', {closestIndex: this.markClosestIndex})
    },
    pressDownRight() {
      this.markClosestIndex++
      const maxIndex = this.seriesData.length - 1
      if (this.markClosestIndex > maxIndex) return this.markClosestIndex = maxIndex
      this.getClickData({closestIndex: this.markClosestIndex})
      this.$emit('getClickData', {closestIndex: this.markClosestIndex})
    },
    handleKeyDown(e) {
      if (!this.isActive) return; // ✅ 只在激活的图表上响应
      if (e.key === 'ArrowLeft') {
        this.pressDownLeft()
      } else if (e.key === 'ArrowRight') {
        this.pressDownRight()
      }
    },
    toggleFullscreen() {
      const el = this.$refs.chartRef;
      if (!document.fullscreenElement) {
        el.requestFullscreen()
      } else {
        document.exitFullscreen();
      }
    },
    exportImg() {
      const base64 = this.echartRef.getDataURL({
        type: 'png',
        pixelRatio: 2,
        backgroundColor: '#fff'
      });

      const link = document.createElement('a');
      link.href = base64;
      link.download = this.chartName + '.png';
      link.click();
    },
    clearChart() {
      if (this.echartRef) this.echartRef.clear();
    },
    resizeChart() {
      if (this.echartRef) {
        this.$nextTick(() => {
          this.echartRef.resize();
        });
      }
    },
    handleFullscreenChange() {
      this.$nextTick(() => {
        this.resizeChart();
      });
    },
    initChart() {
      const element = this.$refs[this.elRef]
      if (element && this.options) {
        this.echartRef = this.$echarts.init(element);
        this.echartRef.setOption(this.options);
        this.echartRef.on('legendselectchanged', this.handleLegendChange);
        this.echartRef.getDom().addEventListener('click', this.handleChartClick);
        this.echartRef.on('datazoom', this.handleDataZoom);
        this.enableZoom()
        // this.chart.focus()
      }
    },
    enableZoom() {
      this.isZoomActive = true;
      this.echartRef.dispatchAction({
        type: 'takeGlobalCursor',
        key: 'dataZoomSelect',
        dataZoomSelectActive: this.isZoomActive
      });
    },
    handleLegendChange(params) {
      this.$emit('legendselectchanged', params)
    },
    removeLegendSelectChangedListener() {
      if (this.echartRef) {
        this.echartRef.off('legendselectchanged');
        this.echartRef.off('click', this.handleChartClick);
        this.echartRef.off('datazoom');
      }
    },
    handleChartClick(params) {
      this.isActive = true;
      this.chart.focus()
      // 通知其他图表取消激活
      window.dispatchEvent(new CustomEvent('chart-active-change', {detail: this._uid}));
      const isData = !Array.isArray(this.options.series) && !this.options.series?.data?.length
      if (this.isStartZoom || isData) return;
      // 保持原有逻辑不变
      const xCoord = params.offsetX;
      const yCoord = params.offsetY;
      const pixel = [xCoord, yCoord];
      if (!this.echartRef.containPixel({gridIndex: 0}, pixel)) {
        return;
      }
      const data = this.echartRef.convertFromPixel('grid', pixel);
      if (data && data[0] && data[1]) {
        const seriesData = this.seriesData;
        this.$emit('click', {dataIndex: data[0], postion: data, pixel: pixel});
        if (this.isClick) {//如果是value轴
          if (!Array.isArray(seriesData) || !seriesData.length) return
          const clickedX = data[0];
          let closestIndex = 0;
          if (this.xType === 'time') {
            let minDiff = Math.abs(dayjs(seriesData[0][0]).valueOf() - clickedX);
            for (let i = 1; i < seriesData.length; i++) {
              let itemData = seriesData[i][0]
              itemData = dayjs(itemData).valueOf()
              const diff = Math.abs(itemData - clickedX);
              if (diff < minDiff) {
                minDiff = diff;
                closestIndex = i;
              }
            }
            this.$emit('getClickData', {closestIndex})
            this.getClickData({closestIndex})
          } else {
            let minDiff = Math.abs(seriesData[0][0] - clickedX);
            for (let i = 1; i < seriesData.length; i++) {
              const diff = Math.abs(seriesData[i][0] - clickedX);
              if (diff < minDiff) {
                minDiff = diff;
                closestIndex = i;
              }
            }
            this.$emit('getClickData', {closestIndex})
            this.getClickData({closestIndex})
          }

        }
      }
    },
    updateMarks(graphicElements = this.graphicElements) {
      this.graphicElements = graphicElements
      if (this.harmonicsEnabled) this.addMarkLine(1)
      if (this.sidebandEnabled) {
        this.sidebandInterval = this.sidebandInterval || this.markClosestIndex
        this.addMarkLine(2)
      }
      const graphic = [...this.graphicElements] || [];
      const chartHeight = this.chart.clientHeight;
      const chartWidth = this.chart.clientWidth;
      this.markList = this.markData.isNew ? [...this.marks, ...[this.markData]] : this.marks;
      if (this.doubleCursorEnabled && this.markList?.length) {
        const closest = this.seriesData[this.doubleCursorCoordX];
        this.doubleCursorMark = {
          id: 'mark-doubleCursor' + this.doubleCursorCoordX + +Date.now(),
          dataCoord: closest,
          isNew: true,
          type: 'doubleCursor',
        }
        const markClosest = this.markData.dataCoord
        this.doubleCursorText = ''
        const f = (1 / markClosest[0] * 1000).toFixed(2)
        const amp = (markClosest[1] - closest[1]).toFixed(2)
        const t = (markClosest[0] - closest[0]).toFixed(2)
        if (this.chartType === 'wave') {
          this.doubleCursorText = `\nΔF=${f}Hz, ΔAmp=${amp}mm/s,Δt=${t}ms`
        } else if (this.chartType === 'spectrum') {
          this.doubleCursorText = `\nΔF=${t}Hz, ΔAmp=${amp}mm/s`
        }
        this.markData.text = this.markText + this.doubleCursorText
        this.markList.push(this.doubleCursorMark)
      }
      this.markList.forEach(mark => {
        // 重新计算当前像素坐标（响应视图变化）
        const currentPixel = this.convertToPixel(mark.dataCoord);
        const currentPixelNew = mark.dataCoordNew ? this.convertToPixel(mark.dataCoordNew) : [null, null];
        const [currentPixelX, currentPixelY] = currentPixel
        const [currentPixelXNew, currentPixelYNew] = currentPixelNew
        const X = currentPixelXNew || currentPixelX
        const Y = currentPixelYNew || currentPixelY
        const gridRect = this.getGridRect();
        const invisible = (
            X < gridRect.x ||
            X > gridRect.x + gridRect.width ||
            Y < gridRect.y ||
            Y > gridRect.y + gridRect.height
        );
        let offsetX = 20;
        if (currentPixelX + 100 > chartWidth) {
          offsetX = -100;
        }
        if (mark.type === 'doubleCursor') {
          graphic.push(              // 垂直连接线
              {
                invisible: !mark.isNew || invisible,
                type: 'line',
                id: mark.id + '-vline',
                $action: 'replace',
                shape: {
                  x1: currentPixelX,
                  y1: 50,
                  x2: currentPixelX,
                  y2: chartHeight - 40
                },
                style: {stroke: '#0000FF', lineWidth: 1},
                z: 200,
                draggable: true,
                // 拖拽开始时设置标志
                ondragstart: () => {
                  this.isDragging = true;
                },
                // 拖拽结束时获取最终位置
                ondragend: (e) => {
                  const {target, offsetX, offsetY} = e
                  const pixel = [offsetX, offsetY];
                  const dataCoord = this.convertFromPixel(target.position);
                  this.doubleCursorMark.dataCoordNew = dataCoord
                  const seriesData = this.seriesData;
                  const data = this.convertFromPixel(pixel);
                  const clickedX = data[0];
                  let minDiff = Math.abs(seriesData[0][0] - clickedX);
                  for (let i = 1; i < seriesData.length; i++) {
                    const diff = Math.abs(seriesData[i][0] - clickedX);
                    if (diff < minDiff) {
                      minDiff = diff;
                      this.doubleCursorCoordX = i;
                    }
                  }
                  this.updateMarks()
                  setTimeout(() => {
                    this.isDragging = false;
                  }, 300);
                }
              },
              // 标记点
              {
                invisible,
                type: 'circle',
                id: mark.id + '-point',
                $action: 'replace',
                shape: {
                  cx: currentPixelX,
                  cy: currentPixelY,
                  r: 3
                },
                style: {
                  fill: '#0000FF',
                  stroke: '#fff',
                  lineWidth: 1
                },
                z: 200
              },)
        } else {
          // 更新图形元素
          graphic.push(
              // 垂直连接线
              {
                invisible: !mark.isNew || invisible,
                type: 'line',
                id: mark.id + '-vline',
                $action: 'replace',
                shape: {
                  x1: currentPixelX,
                  y1: 55,
                  x2: currentPixelX,
                  y2: chartHeight - 40
                },
                style: {stroke: 'red', lineWidth: 1, lineDash: [5, 3]},
                z: 200
              },
              // 标记点
              {
                invisible,
                type: 'circle',
                id: mark.id + '-point',
                $action: 'replace',
                shape: {
                  cx: currentPixelX,
                  cy: currentPixelY,
                  r: 3
                },
                style: {
                  fill: 'red',
                  stroke: '#fff',
                  lineWidth: 1
                },
                z: 201
              },
              // 文本框组（可拖动）
              {
                invisible,
                type: 'group',
                id: mark.id + '-text-group',
                $action: 'replace',
                x: X + offsetX,
                y: Y,
                silent: false,
                z: 200,
                draggable: true,
                children: [
                  // 文本背景
                  {
                    type: 'text',
                    invisible: (X + offsetX < gridRect.x ||
                        X + offsetX > gridRect.x + gridRect.width ||
                        Y < gridRect.y ||
                        Y > gridRect.y + gridRect.height),
                    style: {
                      text: mark.text,
                      ...graphicTextStyle
                    },
                    z: 201,
                    position: [0, -30]
                  }
                ],
                // 拖拽开始时设置标志
                ondragstart: () => {
                  this.isDragging = true;
                },
                // 拖拽结束时获取最终位置
                ondragend: (e) => {
                  const {target} = e
                  const markId = mark.id
                  const dataCoord = this.convertFromPixel(target.position);
                  const index = this.marks.findIndex(v => v.id === markId)
                  if (index !== -1) {
                    this.marks[index].dataCoordNew = dataCoord
                  } else {
                    this.markData.dataCoordNew = dataCoord
                  }
                  this.updateMarks()
                  setTimeout(() => {
                    this.isDragging = false;
                  }, 300);
                }
              },
              // 连接线
              {
                invisible,
                type: 'line',
                id: mark.id + '-connector',
                $action: 'replace',
                shape: {
                  x1: X + offsetX,
                  y1: Y - 20,
                  x2: currentPixelX,
                  y2: currentPixelY
                },
                style: {
                  stroke: '#b8b4b4',
                  lineWidth: 1,
                  lineDash: [4, 2]
                },
                z: 199
              }
          );
        }

      });
      // 更新图表
      this.updateChartGraphic({graphic})
    },
    save() {
      if (this.form.harmonicsNum) {
        if (this.harmonicsEnabled) this.addMarkLine(1)
      }
      this.visible = false
    },
    // 清除标注逻辑
    clearMarks() {
      this.marks = []
      if (!this.markData.isNew) this.markData = {}
      this.updateMarks()
    },
    exportToExcel(data) {
      const name = this.chartName + '数据'
      // 转换为二维数组
      const worksheetData = [['x', 'y']];
      data.forEach(item => {
        worksheetData.push(item);
      });
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, name);

      // 生成并触发下载
      XLSX.writeFile(workbook, name + '.xlsx');
    },
    getClickData(e) {
      // 如果正在拖拽，不处理点击事件
      if (this.isDragging) {
        return;
      }
      const {closestIndex} = e
      const closest = this.seriesData[closestIndex]
      if (!closest) return
      this.markClosestIndex = closestIndex
      // 生成唯一ID
      const markId = 'mark-' + Date.now();
      // 存储原始数据坐标（用于后续更新）
      this.markText = `X: ${closest[0]}\nY: ${closest[1]}`;
      this.markData = {
        id: markId,
        dataCoord: closest,
        text: `${this.markText}${this.doubleCursorText}`,
        isNew: true,
      };

      // 添加到存储数组
      this.marks = this.marks || [];
      // 更新标注
      this.updateMarks();
    },
    handleDataZoom(params) {
      this.isStartZoom = true
      // 关键修复：仅在非程序同步的缩放时，才触发事件传递
      if (!this.isSyncZoom) {
        this.emitZoomDebounced(params);
      }
    },
    createDebouncedResizeHandler() {
      this.resizeHandler = debounce(() => {
        if (this.echartRef) {
          this.echartRef.resize();
        }
      }, 100);
      this.emitZoomDebounced = debounce((params) => {
        this.$emit("onZoom", params);
        this.handleChartZoom()
        this.isStartZoom = false
      }, 300);
    },
    handleChartZoom() {
      this.updateMarks();
    },
    contentResizeHandler(e) {
      if (e.propertyName === 'width') {
        this.resizeHandler();
      }
    },
    convertFromPixel(postion) {
      let result = this.echartRef.convertFromPixel('grid', postion);
      return result;
    },
    convertToPixel(postion) {
      let result = this.echartRef.convertToPixel({xAxisIndex: 0, yAxisIndex: 0}, postion);
      return result;
    },
    getGridRect() {
      return this.echartRef.getModel().getComponent('grid').coordinateSystem.getRect();
    },
    updateChartGraphic(options) {
      this.echartRef.setOption({
        ...options
      }, {
        replaceMerge: ['graphic']
      })
    },
    updateChartOption(options) {
      this.echartRef.setOption({
        ...options
      })
    },
    getChartOption() {
      return this.echartRef.getOption()
    },
    dispatchChartAction(data, withOn = false) {
      this.$nextTick(() => {
        if (this.echartRef) {
          // 关键修复：程序同步缩放时，标记为isSyncZoom=true
          this.isSyncZoom = true;

          const executeAction = () => {
            this.echartRef.dispatchAction(data);
            // 操作完成后重置标记（延迟确保事件触发完成）
            setTimeout(() => {
              this.isSyncZoom = false;
            }, 0);
          };

          if (withOn) {
            this.echartRef.on('finished', () => {
              executeAction();
              this.echartRef.off('finished');
            });
          } else {
            executeAction();
          }
        }
      })
    }
  },
  activated() {
    if (this.echartRef) {
      this.echartRef.resize();
    }
  }
};
</script>
<style lang="scss" scoped>
.echart-box {
  width: 100%;
  height: 100%;
  position: relative;

  .context-menu {
    position: absolute;
    top: 0;
    right: 0;
  }

  .menu-item-active {
    background: var(--dt-bg-hover);
  }
}
</style>
